import React from 'react';
import PropTypes from 'prop-types';

import JBImage from 'components/essentials/JBImage';
import IconQuote from 'components/icons/iconQuote';
import ImageSliderStandard from 'components/consumer/image-slider-standard';

const TestimonialItem = ({
  author_name,
  author_handle,
  author_avatar,
  message,
}) => {
  const split = message.toLowerCase().indexOf('@joybird') > -1;

  let handle;
  let message1;
  let message2;

  // currently this only works for one instance of @joybird in the message
  if (split) {
    let splits = message.split('@Joybird');
    handle = '@Joybird ';

    if (splits.length < 2) {
      handle = '@joybird ';
      splits = message.split('@joybird');
    }

    [message1, message2] = splits;
  }
  return (
    <blockquote className="max-w-[80vw] mx-6 my-0 max-[767px]:max-w-[80vw] max-[767px]:flex-[1_1] max-[767px]:min-w-[75%] max-[767px]:flex-col max-[767px]:justify-between max-[767px]:items-center max-[767px]:mr-[3.333vw] md:mx-8 md:my-0 lg:mx-8 lg:my-0 min-[1440px]:mx-12 min-[1440px]:my-0">
      <div className="flex justify-center mb-6 min-[1440px]:mb-6 [&_svg]:scale-50 [&_svg]:lg:transform-[scale(.6)]">
        <IconQuote />
      </div>
      {!split && (
        <p className="text-lg mt-0 mx-auto mb-3 text-center max-w-[500px] font-bold">
          {message}
        </p>
      )}

      {split && (
        <p className="text-lg mt-0 mx-auto mb-3 text-center max-w-[500px] font-bold">
          {message1}
          <span className="text-brand">{handle}</span>
          {message2}
        </p>
      )}

      <div className="flex justify-center items-center px-0 py-6">
        <JBImage
          src={author_avatar}
          height={40}
          width={40}
          className="mr-5 rounded-[1000%] bg-[#eee]"
        />
        <div>
          <div className="text-base font-bold">{author_name}</div>
          <div className="text-sm">{author_handle}</div>
        </div>
      </div>
    </blockquote>
  );
};

TestimonialItem.propTypes = {
  author_avatar: PropTypes.string,
  author_handle: PropTypes.string,
  author_name: PropTypes.string,
  message: PropTypes.string,
};

const Testimonials = props => {
  const items = props.config.dataSource;

  if (!items.length) {
    return null;
  }

  const finalSlides = items.map(item => (
    <TestimonialItem {...item} key={item.author_handle} />
  ));
  return (
    <div className="mx-auto my-0 pt-10 px-0 pb-11 md:pt-0 md:px-0 md:pb-[4.75rem]">
      <ImageSliderStandard
        config={{
          children: [...finalSlides],
          sliderConfig: {
            navType: 'Dots',
            visibleSlides: 3,
            imageHeight: 320,
          },
          variation: { value: 'Component' },
        }}
        fullWidth
      />
    </div>
  );
};

Testimonials.propTypes = {
  config: PropTypes.shape({
    dataSource: PropTypes.arrayOf(
      PropTypes.shape({
        author_avatar: PropTypes.string,
        author_handle: PropTypes.string,
        author_name: PropTypes.string,
        message: PropTypes.string,
      })
    ),
  }),
};

export default Testimonials;
